import React from "react"
import styled, { ThemeProvider } from "styled-components"

import responsive from "@styles/responsive"
import theme from "@styles/theme"

import Bio from "@components/Bio"
import GlobalStyle from "@styles/global"
import Header from "@components/Header"
import NavigationFooter from "@components/Navigation/Navigation.Footer"
import Tech from "@components/Tech"

const Layout = props => {
  const { location, children } = props

  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyle />
        <Header location={location} />
        <ContentWrapper>
          <Content>
            <MainWrapper>
              <main>{children}</main>
            </MainWrapper>
            <Aside>
              <Bio />
              <Tech />
            </Aside>
          </Content>
        </ContentWrapper>
        <NavigationFooter />
      </>
    </ThemeProvider>
  )
}

export default Layout

const ContentWrapper = styled.div`
  max-width: ${props => props.theme.sizes.maxWidth};
  margin: 0 auto;
  padding: 0 2rem;
  ${responsive.md} {
    max-width: 760px;
  }
  ${responsive.sm} {
    padding: 0 2rem;
  }
`
const Content = styled.div`
  display: flex;
  align-items: flex-start;
  min-height: 85vh;
  margin-top: 2rem;
  ${responsive.lg} {
    display: block;
  }
  ${responsive.sm} {
    margin-top: 0;
  }
`

const MainWrapper = styled.div`
  width: calc(100% - ${props => props.theme.sizes.bioWidth} - 40px);
  margin-right: 40px;
  ${responsive.lg} {
    width: 100%;
  }
`

const Aside = styled.aside`
  position: sticky;
  top: 2em;
  width: 29rem;

  ${responsive.lg} {
    position: static;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-top: 4rem;
    margin-top: 4rem;
    border-top: 1px solid ${props => props.theme.colors.border};

    .is-card {
      flex-basis: 48%;
    }
  }

  ${responsive.sm} {
    flex-direction: column;
  }
`
